const state = {
  currentTabIndex: 0
}

const fiveWhysTabIndex = 0
const actionsTabIndex = 1
const followsTabIndex = 2

const getters = {
  isFiveWhys: (state) => state.currentTabIndex === fiveWhysTabIndex,
  isActions: (state) => state.currentTabIndex === actionsTabIndex,
  isFollows: (state) => state.currentTabIndex === followsTabIndex
}

const mutations = {
  SET_TAB_INDEX: (state, payload) => {
    state.currentTabIndex = payload
  }
}

const actions = {
  setTabIndex({ commit }, newTabIndex) {
    commit('SET_TAB_INDEX', newTabIndex)
  },

  goToFiveWhys({ commit }) {
    commit('SET_TAB_INDEX', 0)
  },
  goToActions({ commit }) {
    commit('SET_TAB_INDEX', 1)
  },
  goToFollows({ commit }) {
    commit('SET_TAB_INDEX', 2)
  },

  resetTabIndex({ commit }) {
    commit('SET_TAB_INDEX', 0)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
